
// config

// ---------------------------------------------------------------------------------------------------------
// config 
// ---------------------------------------------------------------------------------------------------------

export type AuthzConfig = {

    enableMultiManagers: boolean
}

export const [AuthzConfigProvider, useAuthzConfig] = createReadonlyProvider<AuthzConfig>({ 
    enableMultiManagers: false 
})


// users
// -------------------------------------------------------------------------------

import { User } from 'apprise-core/user';
import { createProvider, createReadonlyProvider } from 'apprise-frontend-core/state/factory';
import { createToggleProvider } from 'apprise-frontend-core/toggle/context';
import { createFormExcludes } from 'apprise-frontend-core/utils/formexcludes';

export const [UserClientCacheProvider, useUserClientCache] = createProvider({
    all: [] as User[],
    refs: [] as User[]
})


// clone
// -------------------------------------------------------------------------------


export const [UserCloneProvider, useUserClone] = createProvider({

    clone: undefined! as User

})

// toggles
// ---------------------------------------------------------------------------------------------------------


export type UserToggles = 'user-download'

export const [UserToggleProvider, useUserToggles] = createToggleProvider<UserToggles>()


// excludes
// ---------------------------------------------------------------------------------------------------------

export type UserExcludes = 'active' | 'fullName' | 'tenant' | 'address' | 'phone' | 'language' | 'note'


export const [UserExcludesProvider, useUserExcludes] = createFormExcludes<UserExcludes>()  // so far no othe excludes.




